import { clockRangeFromInstance } from "../../../../components/RRule/day-timeline-range-source.js";
import { relativeWindowFromClockRange, relativeWindowSegments } from "../relative-window/relative-window-geometry.js";
//#region src/modules/ServicePeriods/activity-evals/instance/absolute-window-axis.ts
function absoluteWindowAxis(window, tz) {
	const range = clockRangeFromInstance(window, tz);
	const relativeWindow = {
		durationMinutes: range.durationMin,
		fromStartMinutes: 0
	};
	return {
		periodDurationMin: range.durationMin,
		periodFromMin: range.fromMin,
		periodToMin: range.toMin,
		relativeDurationMinutes: range.durationMin,
		relativeFromStartMinutes: 0,
		segments: relativeWindowSegments(range.fromMin, range.durationMin, relativeWindow)
	};
}
function parentRelativeWindowAxis(parent, window, tz) {
	const parentRange = clockRangeFromInstance(parent, tz);
	const evalRange = clockRangeFromInstance(window, tz);
	const relativeWindow = relativeWindowFromClockRange(parentRange.fromMin, parentRange.durationMin, evalRange.fromMin, evalRange.toMin);
	return {
		periodDurationMin: parentRange.durationMin,
		periodFromMin: parentRange.fromMin,
		periodToMin: parentRange.toMin,
		relativeDurationMinutes: relativeWindow.durationMinutes,
		relativeFromStartMinutes: relativeWindow.fromStartMinutes,
		segments: relativeWindowSegments(parentRange.fromMin, parentRange.durationMin, relativeWindow)
	};
}
//#endregion
export { absoluteWindowAxis, parentRelativeWindowAxis };

//# sourceMappingURL=absolute-window-axis.js.map